import React from "react";
import { TickFilledIcon } from "./Icons/TickFilledIcon";

interface RadioListItemProps {
  label: string;
  selected: boolean;
  onSelect: (newState: boolean) => void;
  className?: string;
  
}

const RadioListItem: React.FC<RadioListItemProps> = ({
  label,
  selected,
  onSelect,
  className = "",
}) => {
  return (
    <div
      className={`radio-list-item ${selected ? "active" : ""} ${className}`}
      onClick={() => onSelect(!selected)} 
    >
      {selected && <TickFilledIcon width={20} height={20} />}
      <div className="radio-list-item__text">{label}</div>
    </div>
  );
};

export default RadioListItem;